import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEraser24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEraser24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m13.67 4.604 2.416 2.416-5.922 5.922-2.416-2.416zm-2.445 9.398 5.922-5.922 2.416 2.416-5.922 5.922zm-4.537-2.416L4.83 13.443a1.5 1.5 0 0 0 0 2.12l3.772 3.772a1.5 1.5 0 0 0 2.121 0l1.856-1.856zm6.982-9.104 1.06 1.061 5.893 5.893 1.061 1.06-1.06 1.061-8.84 8.839a3 3 0 0 1-4.242 0l-3.771-3.771a3 3 0 0 1 0-4.243l8.839-8.839zM15.75 19.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEraser24);
